import React, { useEffect, useRef, useState } from "react";
import { Globe, Check, Loader2 } from "lucide-react";
import { LANGUAGES, useTranslation } from "../context/TranslationContext";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, translating } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen((s) => !s)}
        data-testid="language-switcher-toggle"
        className={`inline-flex items-center gap-1.5 text-sm transition-colors ${
          compact ? "text-navy/80 hover:text-navy" : "text-navy/80 hover:text-navy"
        }`}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <Globe size={16} />
        <span className="hidden md:inline">{current.label.split(" ")[0]}</span>
        <span className="md:hidden">{current.code.toUpperCase()}</span>
        {translating && <Loader2 size={12} className="animate-spin text-saffron ml-1" />}
      </button>
      {open && (
        <div
          role="listbox"
          data-testid="language-switcher-menu"
          className="absolute right-0 top-full mt-2 w-60 bg-pearl border border-navy/15 shadow-lg rounded-sm py-2 z-50 max-h-[70vh] overflow-y-auto"
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              data-testid={`language-option-${l.code}`}
              className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between hover:bg-navy/5 ${
                l.code === lang ? "text-navy font-medium" : "text-navy/75"
              }`}
            >
              <span>{l.label}</span>
              {l.code === lang && <Check size={14} className="text-saffron" />}
            </button>
          ))}
          <div className="px-4 pt-2 mt-1 border-t border-navy/10 text-[11px] italic text-navy/60">
            Powered by AI · Buddhist terms preserved
          </div>
        </div>
      )}
    </div>
  );
}
